import React from "react";
import { ArrowRight, Ship, Anchor, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GlobalLogisticsExcellence() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: buttonsRef,
    isVisible: buttonsVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="4468" id="strategic-maritime-solutions" className="relative min-h-[85vh] w-full flex items-center overflow-hidden bg-background dark">
      {}
      <div className="absolute inset-0 z-0">
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576388/img/maritime_terminal_at_blue_hour.png)] bg-cover bg-center grayscale opacity-40" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-transparent" />
      </div>

      <div className="relative z-10 container mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl">
          {}
          <div className={`flex items-center gap-3 mb-6 transition-all duration-700 delay-100 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="h-[1px] w-12 bg-primary" />
            <span className="font-mono text-xs uppercase tracking-widest text-primary font-medium">
              Operational Excellence
            </span>
          </div>

          {}
          <div ref={textRef} className={`transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="font-serif font-bold bg-clip-text text-transparent bg-[linear-gradient(110deg,#fff,hsl(42,52%,92%),hsl(42,52%,55%),hsl(42,52%,92%),#fff)] bg-[length:200%_100%] animate-[shimmer_8s_linear_infinite] leading-[1.1] tracking-tighter mb-8 !text-[50px]">Integrated Maritime  Procurement & Ship Supply Coordination Brokerage</h1>
            
            <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mb-12">
              Connecting commercial vessels with trusted maritime suppliers and technical service providers across the Atlantic and Caribbean regions through precision-led logistics.
            </p>
          </div>

          {}
          <div ref={buttonsRef} className={`flex flex-col sm:flex-row gap-4 transition-all duration-1000 delay-300 ease-out ${buttonsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Button asChild size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 text-base font-semibold shadow-xl">
              <Link to="#request-quote-home">Request Ship Supply Quote</Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="rounded-lg border-white/20 bg-white/5 text-white hover:bg-white/10 hover:border-white/40 h-14 px-8 text-base font-semibold transition-all">
              <Link to="/GlobalNetworkPage">
                <Globe className="mr-2 size-4 text-primary" />
                Global Network
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 right-0 p-8 hidden lg:block opacity-20">
        <div className="flex flex-col items-end gap-2 font-mono text-[10px] text-white tracking-[0.2em] uppercase">
          <span>Vessel Coord: 9.0748° N, 79.5204° W</span>
          <span>Panama Canal Logistics Terminal</span>
          <div className="h-[1px] w-32 bg-primary mt-2" />
        </div>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 z-20 -translate-x-1/2 hidden md:block">
        <div className="flex flex-col items-center gap-4">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">Registry</span>
          <div className="h-20 w-[1px] bg-gradient-to-b from-primary via-primary/50 to-transparent animate-pulse" />
        </div>
      </div>
    </section>;
}